const clientToken = import.meta.env.VITE_PAYMENTS_CLIENT_TOKEN as string | undefined;

export function PaymentTestModeBanner() {
  // Mai esporre informazioni di test agli utenti finali in produzione.
  if (import.meta.env.PROD) return null;
  if (!clientToken) {
    return (
      <div className="w-full bg-red-100 border-b border-red-300 px-4 py-2 text-center text-sm text-red-800">
        I pagamenti in produzione non sono ancora configurati.
      </div>
    );
  }
  if (clientToken.startsWith("pk_test_")) {
    return (
      <div className="w-full bg-orange-100 border-b border-orange-300 px-4 py-2 text-center text-sm text-orange-800">
        Modalità test: usa la carta 4242 4242 4242 4242 per provare il checkout.
      </div>
    );
  }
  return null;
}